import LiveCallTable from 'components/tables/live-call/LiveCallTable'
import React from 'react'

const index = () => {
    return (
        <LiveCallTable />
    )
}

export default index